import { Opts } from "../types";

interface Getter {
  get(id: string, opts: Opts): Promise<any>;
}

export const cachingService = <T extends Getter>(service: T) => {
  const callCache: { [key: string]: Promise<any> | undefined } = {};

  const actualGet = service.get;

  service.get = async (id: string, opts: Opts) => {
    if (!(id in callCache)) {
      callCache[id] = actualGet.bind(service)(id, opts);
    }
    const response = await callCache[id];
    return { ...response };
  };

  return service;
};
